"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentState = exports.PageState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var store_1 = require("../store");
var collection_edit_state_1 = require("./collection.edit.state");
var collection_link_state_1 = require("./collection.link.state");
var tag_selection_state_1 = require("./tag.selection.state");
var PageState = /** @class */ (function () {
    function PageState() {
        this.Tag = new tag_selection_state_1.TagSelectionState(this);
        this.CollectionLink = new collection_link_state_1.CollectionLinkState();
        this.isGoogleMapsLoaded = false;
        this.isCtrlShiftPressed = false;
        this.hoverId = null;
        this.inspectedTagId = null;
        this.inspectedCollectionRevision = null;
        this.inspectedCaptureId = null;
        this.inspectedFieldId = null;
        this.expandedTagId = null;
        this._lastEditState = new collection_edit_state_1.CollectionEditState(null);
        this.reset();
    }
    PageState.prototype.setIsCtrlShiftPressed = function (selected) {
        this.isCtrlShiftPressed = selected;
    };
    Object.defineProperty(PageState.prototype, "CollectionEdit", {
        get: function () {
            if (this._lastEditState.collectionRevision === this.inspectedCollectionRevision) {
                return this._lastEditState;
            }
            if (this.inspectedCollectionRevision == null) {
                this._lastEditState = new collection_edit_state_1.CollectionEditState(null);
                return this._lastEditState;
            }
            var collection = store_1.AppStore.Collection.get(this.inspectedCollectionRevision);
            if (collection == null) {
                this._lastEditState = new collection_edit_state_1.CollectionEditState(null);
                return this._lastEditState;
            }
            this._lastEditState = new collection_edit_state_1.CollectionEditState(collection);
            return this._lastEditState;
        },
        enumerable: false,
        configurable: true
    });
    PageState.prototype.clearSelected = function () {
        this.inspectedCaptureId = null;
        this.inspectedCollectionRevision = null;
        this.inspectedTagId = null;
        this.expandedTagId = null;
        this.Tag.reset();
    };
    PageState.prototype.setHoverId = function (hoverId) {
        this.hoverId = hoverId;
    };
    PageState.prototype.setInspectedTagId = function (tagId) {
        this.inspectedTagId = tagId;
    };
    PageState.prototype.setExpandedTagId = function (tagId) {
        this.expandedTagId = tagId;
    };
    PageState.prototype.setInspectedCollection = function (revision, captureId) {
        if (captureId === void 0) { captureId = null; }
        var lastRevision = this.inspectedCollectionRevision;
        var lastCapture = this.inspectedCaptureId;
        this.inspectedCollectionRevision = revision;
        this.inspectedCaptureId = captureId;
        var summary = store_1.AppStore.CollectionSummary.get(revision);
        if (summary != null) {
            var firstTagId = summary.tags[0];
            this.setExpandedTagId(firstTagId);
            this.setInspectedTagId(firstTagId);
        }
        // Reset the linking field state on capture change.
        if (lastRevision === revision && lastCapture !== captureId && lastCapture != null) {
            this.CollectionEdit.cancelLinkFields();
        }
        this.CollectionLink.cancelLinking();
    };
    PageState.prototype.setInspectedFieldId = function (fieldId) {
        this.inspectedFieldId = fieldId;
    };
    PageState.prototype.cancelInteractions = function () {
        this.CollectionEdit.cancelLinkFields();
        this.CollectionLink.cancelLinking();
    };
    PageState.prototype.updateInspectedCollection = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var summary, latestSummary;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.inspectedCollectionRevision == null) {
                            return [2 /*return*/];
                        }
                        summary = store_1.AppStore.CollectionSummary.get(this.inspectedCollectionRevision);
                        if (summary == null) {
                            this.setInspectedCollection(null);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, store_1.AppStore.CollectionSummary.getFetchableByUuid(summary.uuid).refetch()];
                    case 1:
                        latestSummary = _a.sent();
                        if (latestSummary == null || latestSummary.revision === summary.revision) {
                            return [2 /*return*/];
                        }
                        this.setInspectedCollection(latestSummary.revision, this.inspectedCaptureId);
                        return [2 /*return*/];
                }
            });
        });
    };
    PageState.prototype.setInspectedCollectionFailed = function () {
        this.setInspectedCollection(null);
    };
    PageState.prototype.setGoogleMapsLoaded = function () {
        this.isGoogleMapsLoaded = true;
    };
    PageState.prototype.reset = function () {
        this.hoverId = null;
        this.inspectedCaptureId = null;
        this.inspectedCollectionRevision = null;
        this.inspectedTagId = null;
        this.expandedTagId = null;
        this.Tag.reset();
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], PageState.prototype, "isGoogleMapsLoaded", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PageState.prototype, "isCtrlShiftPressed", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PageState.prototype, "hoverId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PageState.prototype, "inspectedTagId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PageState.prototype, "inspectedCollectionRevision", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PageState.prototype, "inspectedCaptureId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PageState.prototype, "inspectedFieldId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PageState.prototype, "expandedTagId", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "setIsCtrlShiftPressed", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PageState.prototype, "CollectionEdit", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "clearSelected", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "setHoverId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "setInspectedTagId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "setExpandedTagId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "setInspectedCollection", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "setInspectedFieldId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "setInspectedCollectionFailed", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "setGoogleMapsLoaded", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PageState.prototype, "reset", null);
    return PageState;
}());
exports.PageState = PageState;
exports.CurrentState = new PageState();
//# sourceMappingURL=page.state.js.map